import React from 'react';
import { Link } from 'react-router-dom';
import { ADMIN_ACTION_SOURCES } from '../../constants/adminNav';
import { visibleAdminInboxItems } from './adminDashboardDisplay';

const SEVERITY_STYLES = {
  warning: 'border-amber-300 bg-amber-50',
  info: 'border-sky-200 bg-sky-50',
  critical: 'border-red-300 bg-red-50',
};

export default function AdminActionCenter({ actions, role, t }) {
  const items = visibleAdminInboxItems({
    sources: ADMIN_ACTION_SOURCES,
    actions,
    role,
  });

  return (
    <section className="rounded-xl border border-slate-200 bg-white p-4" aria-labelledby="admin-action-center-title">
      <h2 id="admin-action-center-title" className="text-sm font-semibold text-slate-800">
        {t('admin.home.actionCenterTitle')}
      </h2>
      {items.length === 0 ? (
        <p className="mt-2 text-sm text-slate-600">{t('admin.home.actionCenterEmpty')}</p>
      ) : (
        <ul className="mt-3 space-y-2">
          {items.map((item) => (
            <li key={item.id}>
              <Link
                to={item.href}
                className={`flex flex-wrap items-center justify-between gap-2 rounded-lg border px-3 py-2 text-sm hover:border-indigo-300 focus:outline-none focus:ring-2 focus:ring-indigo-500 ${
                  SEVERITY_STYLES[item.severity] || 'border-slate-200 bg-slate-50'
                }`}
              >
                <span className="font-medium text-slate-900">{t(item.titleKey)}</span>
                <span className="flex items-center gap-2">
                  <span className="rounded-full bg-white/80 px-2 py-0.5 text-xs font-semibold text-slate-700">
                    {t(`admin.home.severity.${item.severity}`)}
                  </span>
                  <span className="tabular-nums font-semibold text-slate-900">{item.count}</span>
                </span>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
